import axios from 'axios';

const apiPowerBI = axios.create({
  baseURL: window.url_NOVA_API,
});

apiPowerBI.interceptors.request.use((config) => {
  let token = sessionStorage.getItem("RC_NEOPAV_TOKEN");

  config.headers = {
    ...(config.headers || {}),
    Authorization: token ? `Bearer ${token}` : '',
  };

  return config;
});

export default apiPowerBI;
